/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Pageble} from './Pageble';

export interface PageApiResponse<T> {
  content: T;
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: Pageble;
  size: number;
  sort: { sorted: boolean, unsorted: boolean, empty: boolean };
  totalElements: number;
  totalPages: number;
  aggregations?: any;
  scrollId?: any;
  maxScore?: any;
}
